export default {
    title: 'Promo Credit',
    amount: 'Amount',
    status: 'Status',
    due_date: 'Exp Date',
    spent: 'Spent',
    type: 'Type',
    exp_date_from: 'Exp Date From',
};
